/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-unknown-property */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable no-shadow */
/* eslint-disable no-param-reassign */
/* eslint-disable consistent-return */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable import/no-cycle */
/* eslint-disable no-alert */
/* eslint-disable react/jsx-indent */
/* eslint-disable no-restricted-globals */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useState, useCallback } from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { NumericTextBoxComponent, SliderComponent } from '@syncfusion/ej2-react-inputs';
import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns';

import { ButtonComponent, CheckBoxComponent } from '@syncfusion/ej2-react-buttons';
import { KanbanComponent, ColumnsDirective, ColumnDirective } from '@syncfusion/ej2-react-kanban';
import { DialogUtility } from '@syncfusion/ej2-react-popups';
import { useNavigate } from 'react-router-dom';
import { useStateContext } from '../contexts/ContextProvider';
import { Header } from '.';

import '../pages/inventory.css';
import '../pages/Zackat.css';

export default React.memo(({ dt }) => {
  const navigate = useNavigate();
  let usr = localStorage.getItem('user');

  let selectedOrg = localStorage.getItem('organization');
  if (!usr || !selectedOrg) {
    // Redirect
    navigate('/login?landing=jobs');
    return <p>Please login... </p>;
  }
  usr = JSON.parse(usr);
  selectedOrg = JSON.parse(selectedOrg);
  const { REACT_APP_API_ENDPOINT } = process.env;
  const [cfgHeader, setCfgHeader] = useState(`Configuration for ${dt.name ? dt.name : dt.title}`);
  let dialogInstance;
  const { collapseConfiguration, setCollapseConfiguration, boss } = useStateContext();

  function dialogClick(f, hdr, content, e) {
    const ok = null;
    dialogInstance = DialogUtility.confirm({
      title: hdr,
      content,
      okButton: ok,
      cancelButton: { text: 'Cancel', click: () => { dialogInstance.hide(); } },
      showCloseIcon: true,
      closeOnEscape: true,
      isModal: true,
      animationSettings: { effect: 'Zoom' },
    });
  }
  let kanbanObj;
  const tooltip = { placement: 'After', isVisible: true, showOn: 'Always' };
  const ticks = {
    placement: 'Before',
    format: 'N0',
    largeStep: 2,
    smallStep: 1,
    showSmallTicks: true,
  };
  const [data, setData] = useState([]);
  const [orig, setOriginal] = useState({});
  const [configState, setConfigState] = useState('');
  const [loading, setLoading] = useState(true);
  const [showCBTAdd, setShowCBTAdd] = useState(false);
  const [showHRMAdd, setShowHRMAdd] = useState(false);
  const [showCHKAdd, setShowCHKAdd] = useState(false);
  const [showOtherAdd, setShowOtherAdd] = useState(false);
  const [showRRMAdd, setShowRRMAdd] = useState(false);
  const [showOXMAdd, setShowOXMAdd] = useState(false);
  const reelFieldSettings = { text: 'text', value: 'value' };

  const [cbtState, setCBTState] = useState('');
  const [hrmState, setHRMState] = useState('');
  const [rrmState, setRRMState] = useState('');
  const [oxmState, setOXMState] = useState('');
  const [chkState, setChkState] = useState('');
  const [otherState, setOtherState] = useState('');

  // const reelDatasource = ['E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M'];
  const reelDatasource = [
    { value: 'n/a', text: 'Factory Default', color: '#F6821E' },
    { value: 'E', text: 'E', color: '#FCDAE2' },
    { value: 'F', text: 'F', color: '#FFEDC2' },
    { value: 'G', text: 'G', color: '#9AF9D3' },
    { value: 'H', text: 'H', color: '#C5EDFA' },
    { value: 'I', text: 'I', color: '#FFDFCE' },
    { value: 'J', text: 'J', color: '#FFD1FF' },
    { value: 'K', text: 'K', color: '#D1DFE8' },
    { value: 'L', text: 'L', color: '#E6EFC3' },
    { value: 'M', text: 'M', color: '#D9D4F8' },
  ];
  const itemTemplate = (props) => {
    // Logic to determine color based on data (e.g., data.colorField)
    const itemStyle = {
      backgroundColor: props.color || 'white', // Use a color from your data source
      padding: '10px, 10px',
    };
    return (
      <div style={itemStyle}>
        {props.text}
      </div>
    );
  };

  const [selReel, setReel] = useState('');
  let slider;
  const onDialogOpen = (args) => {
    args.cancel = true;
  };

  const onCardDoubleClick = (args) => {
    args.cancel = true;
  };

  useEffect(() => {
    // limit associates to the overall selection
    // fetch data
    const dataFetch = async () => {
      try {
        const url = `${REACT_APP_API_ENDPOINT}/configuration?id=${dt._id}&orgid=${dt.organizationid}`;
        const mydata = await (
          await fetch(url, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `JWTToken ${usr.token}`,
            },
          })
        ).json();
        const configData = [];
        if (mydata.organizationid !== dt._id && dt.title) {
          setCfgHeader(`Organization Configuration for ${dt.name ? dt.name : dt.title} (Inherited: ${mydata.organization})`);
        } else if (mydata.associateid && mydata.associateid === dt._id && dt.name) {
          setCfgHeader(`Associate Configuration for ${dt.name ? dt.name : dt.title}`);
        } else if (!mydata.associateid && mydata.organizationid !== dt._id) {
          setCfgHeader(`Associate Configuration for ${dt.name ? dt.name : dt.title} (Inherited: ${mydata.organization})`);
        } else if (dt.name) {
          setCfgHeader(`Configuration for Associate ${dt.name}`);
        } else if (dt.title) {
          setCfgHeader(`Configuration for Organization ${dt.title}`);
        } else {
          setCfgHeader(`Configuration for ${dt.name ? dt.name : dt.title}`);
        }
        if (mydata && !mydata.organizationid) {
          // This means there is no Associate Configuration and we defaulted to the parent organization
          setShowCBTAdd(false);
          setShowHRMAdd(false);
          setShowCHKAdd(false);
          setShowRRMAdd(false);
          setShowOXMAdd(false);
          setShowOtherAdd(false);
        }

        if (mydata && mydata.cbt) {
          if (!mydata.cbt.reel || mydata.cbt.reel === '') {
            mydata.cbt.reel = 'K';
          }
          const cbt = { _id: `${mydata._id}cbt`, status: 'cbt', organization: mydata.organization, organizationid: mydata.organizationid, rawMeas: mydata.cbt.rawMeas, cbtThresh: mydata.cbt.cbtThresh, cbtRpt: mydata.cbt.cbtRpt, cbtCapture: mydata.cbt.cbtCapture, cbtReel: mydata.cbt.reel };
          if (mydata.cbt.state) {
            cbt.state = mydata.cbt.state;
          } else {
            cbt.state = '';
          }
          setCBTState(cbt.state);
          if (cbt.state === 'inactive') {
            setShowCBTAdd(true);
          } else {
            setShowCBTAdd(false);
          }
          configData.push(cbt);
        } else {
          setShowCBTAdd(true);
        }
        if (mydata && mydata.hrm) {
          const hrm = { _id: `${mydata._id}hrm`, status: 'hrm', organization: mydata.organization, organizationid: mydata.organizationid, hrmMeas: mydata.hrm.hrmMeas, hrmRpt: mydata.hrm.hrmRpt, hrmCapture: mydata.hrm.hrmCapture, hrmHiThresh: mydata.hrm.hrmHiThresh };
          if (mydata.hrm.state) {
            hrm.state = mydata.hrm.state;
          } else {
            hrm.state = '';
          }
          setHRMState(hrm.state);
          configData.push(hrm);
          if (hrm.state === 'inactive') {
            setShowHRMAdd(true);
          } else {
            setShowHRMAdd(false);
          }
        } else {
          setShowHRMAdd(true);
        }
        if (mydata && mydata.rrm) {
          const rrm = { _id: `${mydata._id}rrm`, status: 'rrm', organization: mydata.organization, organizationid: mydata.organizationid, rrmMeas: mydata.rrm.rrmMeas, rrmRpt: mydata.rrm.rrmRpt, rrmCapture: mydata.rrm.rrmCapture, rrmHiThresh: mydata.rrm.rrmHiThresh };
          if (mydata.rrm.state) {
            rrm.state = mydata.rrm.state;
          } else {
            rrm.state = '';
          }
          setRRMState(rrm.state);
          if (rrm.state === 'inactive') {
            setShowRRMAdd(true);
          } else {
            setShowRRMAdd(false);
          }
          configData.push(rrm);
        } else {
          setShowRRMAdd(true);
        }
        if (mydata && mydata.oxm) {
          const oxm = { _id: `${mydata._id}oxm`, status: 'oxm', organization: mydata.organization, organizationid: mydata.organizationid, oxmMeas: mydata.oxm.oxmMeas, oxmRpt: mydata.oxm.oxmRpt, oxmCapture: mydata.oxm.oxmCapture, oxmLowThresh: mydata.oxm.oxmLowThresh };
          if (mydata.oxm.state) {
            oxm.state = mydata.oxm.state;
          } else {
            oxm.state = '';
          }
          setOXMState(oxm.state);
          configData.push(oxm);
          if (oxm.state === 'inactive') {
            setShowOXMAdd(true);
          } else {
            setShowOXMAdd(false);
          }
        } else {
          setShowOXMAdd(true);
        }
        if (mydata && mydata.checkin) {
          const checkin = { _id: `${mydata._id}checkin`, status: 'checkin', organization: mydata.organization, organizationid: mydata.organizationid, rawRpt: mydata.checkin.rawRpt };
          if (mydata.checkin.state) {
            checkin.state = mydata.checkin.state;
          } else {
            checkin.state = '';
          }
          setChkState(checkin.state);
          configData.push(checkin);
          if (checkin.state === 'inactive') {
            setShowCHKAdd(true);
          } else {
            setShowCHKAdd(false);
          }
        } else {
          setShowCHKAdd(true);
        }
        if (mydata && mydata.other) {
          if (!mydata.other.duressPeriod || mydata.other.duressPeriod.length === 0) {
            mydata.other.duressPeriod = 5;
          }
          if (mydata.other.noActTimer.length === 0) {
            mydata.other.noActTimer = 15;
          }
          const other = { _id: `${mydata._id}other`, status: 'other', organization: mydata.organization, organizationid: mydata.organizationid, locEnable: mydata.other.enable, locPeriod: mydata.other.period, volume: mydata.other.volume, sst: mydata.other.sst, duress: mydata.other.duress, duressPeriod: mydata.other.duressPeriod, vibe: mydata.other.vibe, noActTimer: mydata.other.noActTimer };
          if (mydata.other.state) {
            other.state = mydata.other.state;
          } else {
            other.state = '';
          }
          setOtherState(other.state);
          configData.push(other);
          if (other.state === 'inactive') {
            setShowOtherAdd(true);
          } else {
            setShowOtherAdd(false);
          }
        } else {
          setShowOtherAdd(true);
        }
        if (mydata.state === 'inactive') {
          setShowCBTAdd(true);
          setShowHRMAdd(true);
          setShowCHKAdd(true);
          setShowRRMAdd(true);
          setShowOXMAdd(true);
          setShowOtherAdd(true);
        }
        setOriginal(mydata);
        setData(configData);
        setConfigState(mydata.state);
        setLoading(false);
      } catch (err) {
        setData([]);
        setLoading(false);
      }
    };
    // set state when the data received
    dataFetch();
  }, []);
  const smsConfiguration = () => {
    const message = '"checkin":"ind"';
    const inventory = { device: dt.device };
    const payload = { inventory, message };
    fetch(`${REACT_APP_API_ENDPOINT}/jasper`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `JWTToken ${usr.token}`,
      },
      body: JSON.stringify(payload),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        dialogClick('na', `SMS Send ${message}`, responseJson.response, null);
        // The added/edited data will be saved in the Grid
      })
      .catch((error) => {
        dialogClick('na', `SMS Send ${message}`, 'error', null);
      });
  };
  const deleteConfiguration = () => {
    if (!orig.state || orig.state === 'active') {
      orig.state = 'inactive';
    } else {
      orig.state = 'active';
    }
    fetch(`${REACT_APP_API_ENDPOINT}/configuration`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `JWTToken ${usr.token}`,
      },
      body: JSON.stringify(orig),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        if (orig.state === 'inactive') {
          DialogUtility.alert(`Delete configuration ${responseJson.response}`);
        } else {
          DialogUtility.alert(`Delete configuration ${responseJson.response}`);
        }
        setCollapseConfiguration(!collapseConfiguration);
        // The added/edited data will be saved in the Grid
      })
      .catch((error) => {
        DialogUtility.alert('Delete configuration error');
      });
  };

  const saveConfiguration = (val, state) => {
    if (dt && dt.name) {
      // Associate mode
      // orig._id = dt._id;
      orig.organizationid = dt.organizationid;
      orig.organization = dt.organization;
      orig.associateid = dt._id;
    } else if (dt && dt.title) {
      // Organization Mode
      orig.organizationid = dt._id;
      // orig._id = dt._id;
      orig.organization = dt.title;
      orig.associateid = '';
    }

    if (val === 'cbt') {
      orig.cbt.rawMeas = parseInt(document.getElementById(`${dt._id}${val}rawMeas`).value, 10);
      orig.cbt.cbtCapture = parseInt(document.getElementById(`${dt._id}${val}cbtCapture`).value, 10);
      orig.cbt.cbtRpt = parseInt(document.getElementById(`${dt._id}${val}cbtRpt`).value, 10);
      orig.cbt.cbtThresh = parseInt(document.getElementById(`${dt._id}${val}cbtThresh`).value, 10);
      const reel = document.getElementById(`${dt._id}${val}reel`);
      if (reel) {
        orig.cbt.reel = reel.value;
      }
      if (!state || state === 'active') {
        orig.cbt.state = 'inactive';
      } else if (state && state === 'inactive') {
        orig.cbt.state = 'active';
      }
    } else if (val === 'hrm') {
      orig.hrm.hrmMeas = parseInt(document.getElementById(`${dt._id}${val}hrmMeas`).value, 10);
      orig.hrm.hrmRpt = parseInt(document.getElementById(`${dt._id}${val}hrmRpt`).value, 10);
      orig.hrm.hrmCapture = parseInt(document.getElementById(`${dt._id}${val}hrmCapture`).value, 10);
      orig.hrm.hrmHiThresh = parseInt(document.getElementById(`${dt._id}${val}hrmHiThresh`).value, 10);
      if (!state || state === 'active') {
        orig.hrm.state = 'inactive';
      } else if (state && state === 'inactive') {
        orig.hrm.state = 'active';
      }
    } else if (val === 'rrm') {
      orig.rrm.rrmMeas = parseInt(document.getElementById(`${dt._id}${val}rrmMeas`).value, 10);
      orig.rrm.rrmRpt = parseInt(document.getElementById(`${dt._id}${val}rrmRpt`).value, 10);
      orig.rrm.rrmCapture = parseInt(document.getElementById(`${dt._id}${val}rrmCapture`).value, 10);
      orig.rrm.rrmHiThresh = parseInt(document.getElementById(`${dt._id}${val}rrmHiThresh`).value, 10);
      if (!state || state === 'active') {
        orig.rrm.state = 'inactive';
      } else if (state && state === 'inactive') {
        orig.rrm.state = 'active';
      }
    } else if (val === 'oxm') {
      orig.oxm.oxmMeas = parseInt(document.getElementById(`${dt._id}${val}oxmMeas`).value, 10);
      orig.oxm.oxmRpt = parseInt(document.getElementById(`${dt._id}${val}oxmRpt`).value, 10);
      orig.oxm.oxmCapture = parseInt(document.getElementById(`${dt._id}${val}oxmCapture`).value, 10);
      orig.oxm.oxmLowThresh = parseInt(document.getElementById(`${dt._id}${val}oxmLowThresh`).value, 10);
      if (!state || state === 'active') {
        orig.oxm.state = 'inactive';
      } else if (state && state === 'inactive') {
        orig.oxm.state = 'active';
      }
    } else if (val === 'checkin') {
      orig.checkin.rawRpt = parseInt(document.getElementById(`${dt._id}${val}rawRpt`).value, 10);
      if (!state || state === 'active') {
        orig.checkin.state = 'inactive';
      } else if (state && state === 'inactive') {
        orig.checkin.state = 'active';
      }
    } else if (val === 'other') {
      orig.other.enable = parseInt(document.getElementById(`${dt._id}${val}locEnable`).value, 10);
      orig.other.period = parseInt(document.getElementById(`${dt._id}${val}locPeriod`).value, 10);
      orig.other.duressPeriod = parseInt(document.getElementById(`${dt._id}${val}duressPeriod`).value, 10);
      orig.other.sst = document.getElementById(`${dt._id}${val}sst`).checked;
      orig.other.duress = document.getElementById(`${dt._id}${val}duress`).checked;
      orig.other.vibe = document.getElementById(`${dt._id}${val}vibe`).checked;
      orig.other.noActTimer = parseInt(document.getElementById(`${dt._id}${val}noActTimer`).value, 10);
      const vol = slider.properties.value;
      orig.other.volume = vol.toString();
      if (!state || state === 'active') {
        orig.other.state = 'inactive';
      } else if (state && state === 'inactive') {
        orig.other.state = 'active';
      }
    } else {
      return;
    }
    if (cbtState === 'inherited') {
      delete orig.cbt;
    } else if (orig.cbt.state === 'inherited' && val === 'cbt') {
      orig.cbt.state = 'active';
    }
    if (hrmState === 'inherited') {
      delete orig.hrm;
    } else if (orig.hrm.state === 'inherited' && val === 'hrm') {
      orig.hrm.state = 'active';
    }
    if (rrmState === 'inherited') {
      delete orig.rrm;
    } else if (orig.rrm.state === 'inherited' && val === 'rrm') {
      orig.rrm.state = 'active';
    }
    if (oxmState === 'inherited') {
      delete orig.oxm;
    } else if (orig.oxm.state === 'inherited' && val === 'oxm') {
      orig.oxm.state = 'active';
    }
    if (chkState === 'inherited') {
      delete orig.checkin;
    } else if (orig.checkin.state === 'inherited' && val === 'checkin') {
      orig.checkin.state = 'active';
    }
    if (otherState === 'inherited') {
      delete orig.other;
    } else if (orig.checkin.state === 'inherited' && val === 'other') {
      orig.other.state = 'active';
    }

    fetch(`${REACT_APP_API_ENDPOINT}/configuration`, {
      method: 'UPDATE',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `JWTToken ${usr.token}`,
      },
      body: JSON.stringify(orig),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        // The added/edited data will be saved in the Grid
        setCollapseConfiguration(!collapseConfiguration);
        if (responseJson && responseJson.response && responseJson.response !== 'OK') {
          dialogClick('na', 'Configuration Update', responseJson.response, null);
        } else {
          dialogClick('na', 'Configuration Update', responseJson.response, null);
        }
      })
      .catch((e) => {
        console.error(e);
        dialogClick('na', 'Configuration Update', 'error updating Configuration', null);
      });
  };
  const showConfirm = (val, state) => {
    // 'GET
    let name = '';
    if (dt.name) {
      name = dt.name;
    } else if (dt.title) {
      name = dt.title;
    } else {
      return;
    }
    if (orig.associateid === dt._id) {
      // This is an Associate Configuration that already exists
      saveConfiguration(val, state);
    } else if (orig.organizationid === dt._id) {
      // This is an Associate Configuration that already exists
      saveConfiguration(val, state);
    } else {
      dialogInstance = DialogUtility.confirm({
        title: 'Confirmation Required',
        content: `Are you sure you want to create a Configuration for ${name}?`,
        okButton: { text: 'OK', click: () => { dialogInstance.hide(); saveConfiguration(val, state); } },
        cancelButton: { text: 'Cancel', click: () => { dialogInstance.hide(); } },
      });
    }
  };
  const actionComplete = (args) => {
    /** Set initial Focus */
    if (args.requestType === 'cardCreated') {
      if (args.addedRecords && confirm('Would you really like to add this entry?')) {
        // The default edit operation is cancelled
        // Here you can send the updated data to your server using AJAX call
        const editedData = args.addedRecords;
        if (editedData.length > 0) {
          editedData[0].id = dt._id;
          fetch(`${REACT_APP_API_ENDPOINT}/configuration`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `JWTToken ${usr.token}`,
            },
            body: JSON.stringify(editedData),
          })
            .then((response) => response.json())
            .then((responseJson) => {
              if (responseJson && responseJson.response && responseJson.response !== 'OK') {
                dialogClick('na', 'Configuration Add', responseJson.response, null);
              } else {
                dialogClick('na', 'Configuration Add', responseJson.response, null);
              }
            })
            .catch(() => {
              dialogClick('na', 'Configuration Add', 'error add job', null);
            });
        }
      }
    } else if (args.requestType === 'cardChanged') {
      if (args) {
        // The default edit operation is cancelled
        // Here you can send the updated data to your server using AJAX call
        const editedData = args.changedRecords;
        if (editedData.length > 0) {
          editedData[0].id = dt._id;
          fetch(`${REACT_APP_API_ENDPOINT}/configuration`, {
            method: 'UPDATE',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `JWTToken ${usr.token}`,
            },
            body: JSON.stringify(editedData),
          })
            .then((response) => response.json())
            .then((responseJson) => {
              // The added/edited data will be saved in the Grid
              if (responseJson && responseJson.response && responseJson.response !== 'OK') {
                dialogClick('na', 'Configuration Update', responseJson.response, null);
              } else {
                dialogClick('na', 'Configuration Update', responseJson.response, null);
              }
            })
            .catch((e) => {
              console.error(e);
              dialogClick('na', 'Configuration Card Changed Update', 'error updating Configuration', null);
            });
        }
      }
    } else if (args.requestType === 'cardRemoved') {
      const editedData = args.deletedRecords;
      if (editedData) {
        // The default edit operation is cancelled
        // Here you can send the updated data to your server using AJAX call
        if (editedData.length > 0) {
          editedData[0].id = dt._id;
          fetch(`${REACT_APP_API_ENDPOINT}/jobs`, {
            method: 'DELETE',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `JWTToken ${usr.token}`,
            },
            body: JSON.stringify(editedData),
          })
            .then((response) => response.json())
            .then((responseJson) => {
              // The added/edited data will be saved in the Grid
              if (responseJson && responseJson.response && responseJson.response !== 'OK') {
                dialogClick('na', 'Configuration Delete', responseJson.response, null);
              } else {
                dialogClick('na', 'Configuration Delete', responseJson.response, null);
              }
            })
            .catch(() => {
              dialogClick('na', 'Configuration Delete', 'error deleting job', null);
            });
        }
      }
    }
  };
  function cardTemplate(props) {
    const rmid = `${dt._id + props.status}rawMeas`;
    const rrid = `${dt._id + props.status}rawRpt`;
    const ccid = `${dt._id + props.status}cbtCapture`;
    const ctid = `${dt._id + props.status}cbtThresh`;
    const crid = `${dt._id + props.status}cbtRpt`;
    const hrmid = `${dt._id + props.status}hrmMeas`;
    const hrrid = `${dt._id + props.status}hrmRpt`;
    const hccid = `${dt._id + props.status}hrmCapture`;
    const hcrid = `${dt._id + props.status}hrmHiThresh`;
    const leid = `${dt._id + props.status}locEnable`;
    const lpid = `${dt._id + props.status}locPeriod`;
    const dpid = `${dt._id + props.status}duressPeriod`;
    const sstid = `${dt._id + props.status}sst`;
    const durid = `${dt._id + props.status}duress`;
    const volid = `${dt._id + props.status}volume`;
    const rrmid = `${dt._id + props.status}rrmMeas`;
    const rrrid = `${dt._id + props.status}rrmRpt`;
    const rccid = `${dt._id + props.status}rrmCapture`;
    const rcrid = `${dt._id + props.status}rrmHiThresh`;
    const oxmid = `${dt._id + props.status}oxmMeas`;
    const oxrid = `${dt._id + props.status}oxmRpt`;
    const oxcid = `${dt._id + props.status}oxmCapture`;
    const oxyid = `${dt._id + props.status}oxmLowThresh`;
    const reelid = `${dt._id + props.status}reel`;
    const vibeid = `${dt._id + props.status}vibe`;
    const natid = `${dt._id + props.status}noActTimer`;
    let bgcolor = 'transparent';
    let cardbg = 'transparent';
    let cardopacity = 1.0;
    if (configState === 'inactive') {
      bgcolor = 'lightgrey';
    }
    if (props.state === 'inactive') {
      cardbg = 'lightgrey'; // '#F6821E';
      cardopacity = 0.50;
    }
    return (
            <div className="card-template" style={{ height: '520px', marginBottom: '2', backgroundColor: bgcolor }}>
                <div
                  style={{
                    border: '2px solid darkgrey',
                    position: 'absolute',
                    zIndex: 1,
                    top: 2,
                    marginBottom: 'auto',
                    backgroundColor: cardbg,
                    opacity: cardopacity,
                    width: 'auto', // or you can use width: '100vw'
                    height: 'auto', // or you can use height: '100vh'
                  }}
                  className="e-card-content e-card-separator"
                >
                  <div className="mt-4">
                    {Object.hasOwn(props, 'rawMeas') && (
                            <NumericTextBoxComponent
                              value={props.rawMeas}
                              id={rmid}
                              placeholder="CBT Measurement"
                              title="CBT Measurement"
                              min={1}
                              max={1}
                              format="N0"
                              validateDecimalOnType
                              decimals={0}
                              floatLabelType="Auto"
                              onChange={() => { if (props.state === 'inherited') { setCBTState('active'); } }}
                            />
                    )}
                  </div>
                    {Object.hasOwn(props, 'cbtCapture') && (
                        <NumericTextBoxComponent
                          id={ccid}
                          value={props.cbtCapture}
                          placeholder="CBT Capture"
                          title="Core Body Temperature Capture"
                          min={1}
                          max={60}
                          format="N0"
                          validateDecimalOnType
                          decimals={0}
                          floatLabelType="Auto"
                          onChange={() => { if (props.state === 'inherited') { setCBTState('active'); } }}
                        />
                    )}
                    {Object.hasOwn(props, 'cbtRpt') && (
                        <NumericTextBoxComponent
                          id={crid}
                          value={props.cbtRpt}
                          placeholder="CBT Report Interval"
                          title="Core Body Report"
                          min={0}
                          max={60}
                          format="N0"
                          validateDecimalOnType
                          decimals={0}
                          floatLabelType="Auto"
                          onChange={() => { if (props.state === 'inherited') { setCBTState('active'); } }}
                        />
                    )}
                    {Object.hasOwn(props, 'cbtThresh') && (
                        <NumericTextBoxComponent
                          id={ctid}
                          value={props.cbtThresh}
                          placeholder="CBT Threshold (°F)"
                          title="Core Body Threshold"
                          min={0}
                          max={100}
                          format="N0"
                          validateDecimalOnType
                          decimals={0}
                          floatLabelType="Auto"
                          onChange={() => { if (props.state === 'inherited') { setCBTState('active'); } }}
                        />
                    )}
                    {Object.hasOwn(props, 'cbtReel') && boss && (
                        <DropDownListComponent
                          id={reelid}
                          width="100%"
                          cssClass="e-outline"
                          dataSource={reelDatasource}
                          fields={reelFieldSettings}
                          itemTemplate={itemTemplate}
                          floatLabelType=""
                          placeholder="Heat Flux Sensitivity"
                          value={props.cbtReel}
                          onChange={() => { if (props.state === 'inherited') { setCBTState('active'); } }}
                        />
                    )}
                    {Object.hasOwn(props, 'hrmMeas') && (
                        <NumericTextBoxComponent
                          value={props.hrmMeas}
                          id={hrmid}
                          placeholder="HRM Measurement"
                          title="HRM Measurement"
                          min={1}
                          max={1}
                          format="N0"
                          validateDecimalOnType
                          decimals={0}
                          floatLabelType="Auto"
                          onChange={() => { if (props.state === 'inherited') { setHRMState('active'); } }}
                        />
                    )}
                    {Object.hasOwn(props, 'hrmCapture') && (
                        <NumericTextBoxComponent
                          id={hccid}
                          value={props.hrmCapture}
                          placeholder="HRM Capture"
                          title="HRM Capture"
                          min={0}
                          max={60}
                          format="N0"
                          validateDecimalOnType
                          decimals={0}
                          floatLabelType="Auto"
                          onChange={() => { if (props.state === 'inherited') { setHRMState('active'); } }}
                        />
                    )}
                    {Object.hasOwn(props, 'hrmRpt') && (
                        <NumericTextBoxComponent
                          id={hrrid}
                          value={props.hrmRpt}
                          placeholder="HRM Report Interval"
                          title="Raw Report"
                          min={1}
                          max={60}
                          format="N0"
                          validateDecimalOnType
                          decimals={0}
                          floatLabelType="Auto"
                          onChange={() => { if (props.state === 'inherited') { setHRMState('active'); } }}
                        />
                    )}
                    {Object.hasOwn(props, 'hrmHiThresh') && (
                        <NumericTextBoxComponent
                          id={hcrid}
                          value={props.hrmHiThresh}
                          placeholder="HRM Threshold"
                          title="HRM Threshold"
                          min={0}
                          max={240}
                          format="N0"
                          validateDecimalOnType
                          decimals={0}
                          floatLabelType="Auto"
                          onChange={() => { if (props.state === 'inherited') { setHRMState('active'); } }}
                        />
                    )}
                    {Object.hasOwn(props, 'rrmMeas') && (
                        <NumericTextBoxComponent
                          value={props.rrmMeas}
                          id={rrmid}
                          placeholder="RRM Measurement"
                          title="RRM Measurement"
                          min={1}
                          max={1}
                          format="N0"
                          validateDecimalOnType
                          decimals={0}
                          floatLabelType="Auto"
                          onChange={() => { if (props.state === 'inherited') { setRRMState('active'); } }}
                        />
                    )}
                    {Object.hasOwn(props, 'rrmCapture') && (
                        <NumericTextBoxComponent
                          id={rccid}
                          value={props.rrmCapture}
                          placeholder="RRM Capture"
                          title="RRM Capture"
                          min={0}
                          max={60}
                          format="N0"
                          validateDecimalOnType
                          decimals={0}
                          floatLabelType="Auto"
                          onChange={() => { if (props.state === 'inherited') { setRRMState('active'); } }}
                        />
                    )}
                    {Object.hasOwn(props, 'rrmRpt') && (
                        <NumericTextBoxComponent
                          id={rrrid}
                          value={props.rrmRpt}
                          placeholder="RRM Report Interval"
                          title="Raw Report"
                          min={1}
                          max={60}
                          format="N0"
                          validateDecimalOnType
                          decimals={0}
                          floatLabelType="Auto"
                          onChange={() => { if (props.state === 'inherited') { setRRMState('active'); } }}
                        />
                    )}
                    {Object.hasOwn(props, 'rrmHiThresh') && (
                        <NumericTextBoxComponent
                          id={rcrid}
                          value={props.rrmHiThresh}
                          placeholder="RRM Threshold"
                          title="RRM Threshold"
                          min={0}
                          max={240}
                          format="N0"
                          validateDecimalOnType
                          decimals={0}
                          floatLabelType="Auto"
                          onChange={() => { if (props.state === 'inherited') { setRRMState('active'); } }}
                        />
                    )}
                    {Object.hasOwn(props, 'oxmMeas') && (
                        <NumericTextBoxComponent
                          value={props.oxmMeas}
                          id={oxmid}
                          placeholder="OXM Measurement"
                          title="OXM Measurement"
                          min={1}
                          max={1}
                          format="N0"
                          validateDecimalOnType
                          decimals={0}
                          floatLabelType="Auto"
                          onChange={() => { if (props.state === 'inherited') { setOXMState('active'); } }}
                        />
                    )}
                    {Object.hasOwn(props, 'oxmCapture') && (
                        <NumericTextBoxComponent
                          id={oxcid}
                          value={props.oxmCapture}
                          placeholder="OXM Capture"
                          title="OXM Capture"
                          min={0}
                          max={60}
                          format="N0"
                          validateDecimalOnType
                          decimals={0}
                          floatLabelType="Auto"
                          onChange={() => { if (props.state === 'inherited') { setOXMState('active'); } }}
                        />
                    )}
                    {Object.hasOwn(props, 'oxmRpt') && (
                        <NumericTextBoxComponent
                          id={oxrid}
                          value={props.oxmRpt}
                          placeholder="OXM Report Interval"
                          title="Raw Report"
                          min={1}
                          max={60}
                          format="N0"
                          validateDecimalOnType
                          decimals={0}
                          floatLabelType="Auto"
                          onChange={() => { if (props.state === 'inherited') { setOXMState('active'); } }}
                        />
                    )}
                    {Object.hasOwn(props, 'oxmLowThresh') && (
                        <NumericTextBoxComponent
                          id={oxyid}
                          value={props.oxmLowThresh}
                          placeholder="OXM Threshold"
                          title="OXM Threshold"
                          min={0}
                          max={240}
                          format="N0"
                          validateDecimalOnType
                          decimals={0}
                          floatLabelType="Auto"
                          onChange={() => { if (props.state === 'inherited') { setOXMState('active'); } }}
                        />
                    )}
                    {Object.hasOwn(props, 'rawRpt') && (
                        <NumericTextBoxComponent
                          id={rrid}
                          value={props.rawRpt}
                          placeholder="Raw Report"
                          title="Raw Report"
                          min={0}
                          max={60}
                          format="N0"
                          validateDecimalOnType
                          decimals={0}
                          floatLabelType="Auto"
                          onChange={() => { if (props.state === 'inherited') { setChkState('active'); } }}
                        />
                    )}
                    {Object.hasOwn(props, 'locEnable') && (
                            <NumericTextBoxComponent
                              value={props.locEnable}
                              id={leid}
                              placeholder="Location Enable"
                              title="Location Enable 0=OFF, 1=Follow Readings, 2=Always ON"
                              min={0}
                              max={2}
                              format="N0"
                              validateDecimalOnType
                              decimals={0}
                              floatLabelType="Auto"
                              onChange={() => { if (props.state === 'inherited') { setOtherState('active'); } }}
                            />
                    )}
                    {Object.hasOwn(props, 'locPeriod') && (
                            <NumericTextBoxComponent
                              value={props.locPeriod}
                              id={lpid}
                              placeholder="Location Period"
                              title="Location Period"
                              min={1}
                              max={240}
                              format="N0"
                              validateDecimalOnType
                              decimals={0}
                              floatLabelType="Auto"
                              onChange={() => { if (props.state === 'inherited') { setOtherState('active'); } }}
                            />
                    )}
                    {Object.hasOwn(props, 'sst') && (
                      <div className="flex">
                      <div className="labeltext">Speech to Text</div>
                        <CheckBoxComponent
                          checked={props.sst}
                          id={sstid}
                          placeholder="Speech to Text Period"
                          title="STT"
                          onChange={() => { if (props.state === 'inherited') { setOtherState('active'); } }}
                        />
                      </div>
                    )}
                    {Object.hasOwn(props, 'duress') && (
                      <div className="flex">
                        <div className="labeltext mb-10">Duress</div>
                        <CheckBoxComponent
                          checked={props.duress}
                          id={durid}
                          placeholder="Duress Location"
                          title="Duress"
                          onChange={() => { if (props.state === 'inherited') { setOtherState('active'); } }}
                        />
                      </div>
                    )}
                    {Object.hasOwn(props, 'duressPeriod') && (
                      <NumericTextBoxComponent
                        value={props.duressPeriod}
                        id={dpid}
                        placeholder="Duress Period"
                        title="Duress Period"
                        min={1}
                        max={240}
                        format="N0"
                        validateDecimalOnType
                        decimals={0}
                        floatLabelType="Auto"
                        onChange={() => { if (props.state === 'inherited') { setOtherState('active'); } }}
                      />
                    )}
                    {Object.hasOwn(props, 'vibe') && (
                      <div className="flex">
                        <div className="labeltext">Vibe</div>
                        <CheckBoxComponent
                          checked={props.vibe}
                          id={vibeid}
                          placeholder="Vibrate"
                          title="Vibrate"
                          onChange={() => { if (props.state === 'inherited') { setOtherState('active'); } }}
                        />
                      </div>
                    )}

                    {Object.hasOwn(props, 'volume') && (
                      <div className="sliderwrap">
                        <div className="labeltext">Volume</div>
                        <div className="wrap">
                          <SliderComponent
                            id={volid}
                            ref={(sliderRef) => { slider = sliderRef; }}
                            title="Volume"
                            type="MinRange"
                            tooltip={tooltip}
                            ticks={ticks}
                            value={props.volume}
                            cssClass="e-ticks"
                            min={0}
                            max={10}
                            step={1}
                            onChange={() => { if (props.state === 'inherited') { setOtherState('active'); } }}
                          />
                        </div>
                      </div>
                    )}
                    {Object.hasOwn(props, 'noActTimer') && (
                      <NumericTextBoxComponent
                        value={props.noActTimer}
                        id={natid}
                        placeholder="No Activity Period"
                        title="No Activity Period"
                        min={0}
                        max={240}
                        format="N0"
                        validateDecimalOnType
                        decimals={0}
                        floatLabelType="Auto"
                        onChange={() => { if (props.state === 'inherited') { setOtherState('active'); } }}
                      />
                    )}
                  <div style={{ bottom: 0, width: '100%' }}>
                    { props.status === 'cbt' && cbtState !== 'inherited' && (
                      <ButtonComponent cssClass="e-small" iconCss="e-icons e-save" style={{ float: 'right' }} onClick={() => { showConfirm(props.status, 'save'); }}>Save</ButtonComponent>
                    )}
                    { props.status === 'hrm' && hrmState !== 'inherited' && (
                      <ButtonComponent cssClass="e-small" iconCss="e-icons e-save" style={{ float: 'right' }} onClick={() => { showConfirm(props.status, 'save'); }}>Save</ButtonComponent>
                    )}
                    { props.status === 'rrm' && rrmState !== 'inherited' && (
                      <ButtonComponent cssClass="e-small" iconCss="e-icons e-save" style={{ float: 'right' }} onClick={() => { showConfirm(props.status, 'save'); }}>Save</ButtonComponent>
                    )}
                    { props.status === 'oxm' && oxmState !== 'inherited' && (
                      <ButtonComponent cssClass="e-small" iconCss="e-icons e-save" style={{ float: 'right' }} onClick={() => { showConfirm(props.status, 'save'); }}>Save</ButtonComponent>
                    )}
                    { props.status === 'checkin' && chkState !== 'inherited' && (
                      <ButtonComponent cssClass="e-small" iconCss="e-icons e-save" style={{ float: 'right' }} onClick={() => { showConfirm(props.status, 'save'); }}>Save</ButtonComponent>
                    )}
                    { props.status === 'other' && otherState !== 'inherited' && (
                      <ButtonComponent cssClass="e-small" iconCss="e-icons e-save" style={{ float: 'right' }} onClick={() => { showConfirm(props.status, 'save'); }}>Save</ButtonComponent>
                    )}
                    {!cfgHeader.includes('Inherited') && (
                      !props.state || props.state === '' || props.state === 'active' ? (
                        <ButtonComponent cssClass="e-small" iconCss="e-icons e-opacity" style={{ float: 'left' }} onClick={() => { showConfirm(props.status, props.state); }}>Active</ButtonComponent>
                      ) : props.state === 'inherited' ? (
                        <ButtonComponent cssClass="e-small" iconCss="e-icons e-freeze-column" disabled style={{ float: 'left' }} onClick={() => { console.log('inherited do nothing'); }}>Inherited</ButtonComponent>
                      ) : (
                        <ButtonComponent cssClass="e-small" iconCss="e-icons e-opacity" style={{ float: 'left' }} onClick={() => { showConfirm(props.status, props.state); }}>Inactive</ButtonComponent>
                      )
                    )}
                  </div>
                </div>
            </div>
    );
  }
  function columnTemplate(props) {
    return (
            <div className="header-template-wrap">
                <div className={`header-icon e-icons ${props.keyField}`} />
                <div className="header-text">{props.headerText}</div>
            </div>
    );
  }
  if (loading) {
    return <p>Loading Configuration...</p>;
  }
  return (
        <div className="md:m-1 mt-24 bg-white rounded-3xl">
            <Header category="" title={cfgHeader} />
            <KanbanComponent
              cssClass="kanban-overview"
              id="kanban"
              keyField="status"
              dataSource={data}
              dialogOpen={onDialogOpen}
              cardDoubleClick={onCardDoubleClick}
                // dialogSettings={{ fields, className: 'e-dialog-delete' }}
              actionComplete={actionComplete}
              allowDragAndDrop={false}
              enablePersistence={false}
                // queryCellInfo={queryCellInfo}
              ref={(kanban) => { kanbanObj = kanban; }}
              cardSettings={{
                headerField: 'organizationid',
                selectionType: 'Single',
                contentField: 'organization',
                template: cardTemplate,
              }}
            >
                <ColumnsDirective>
                    <ColumnDirective headerText="CBT" keyField="cbt" template={columnTemplate} allowToggle isExpanded={!showCBTAdd} showAddButton={false} />
                    <ColumnDirective headerText="HRM" keyField="hrm" template={columnTemplate} allowToggle isExpanded={!showHRMAdd} showAddButton={false} />
                    <ColumnDirective headerText="RRM" keyField="rrm" template={columnTemplate} allowToggle isExpanded={!showRRMAdd} showAddButton={false} />
                     <ColumnDirective headerText="OXM" keyField="oxm" template={columnTemplate} allowToggle isExpanded={!showOXMAdd} showAddButton={false} />
                     {/*
                    <ColumnDirective headerText="BP" keyField="bp" template={columnTemplate} allowToggle isExpanded={!showBPAdd} showAddButton={false} />
                   <ColumnDirective headerText="Hydration" keyField="hyd" template={columnTemplate} allowToggle isExpanded={!showHYDAdd} showAddButton={false} />
                   */}
                    <ColumnDirective headerText="CheckIn" keyField="checkin" template={columnTemplate} allowToggle isExpanded={!showCHKAdd} showAddButton={false} />
                    {/* <ColumnDirective headerText="Accelerometer" keyField="acl" template={columnTemplate} allowToggle isExpanded={!showACTAdd} showAddButton={false} />
                    */}
                    <ColumnDirective headerText="General" keyField="other" template={columnTemplate} allowToggle isExpanded={!showOtherAdd} showAddButton={false} />
                </ColumnsDirective>
            </KanbanComponent>
            {dt.name && (
              <ButtonComponent cssClass="e-small" iconCss="e-icons e-comments" style={{ float: 'right' }} onClick={(e) => { smsConfiguration(); }}>SMS</ButtonComponent>
            )}
            {!cfgHeader.includes('Inherited:') && (
              <ButtonComponent
                cssClass="e-small"
                iconCss="e-icons e-trash"
                style={{ float: 'left' }}
                onClick={(e) => { deleteConfiguration(); }}
              >DELETE
              </ButtonComponent>
            )}
            {/*
            {configState === 'inactive'
              ? <ButtonComponent cssClass="e-small e-opacity" iconCss="e-icons e-save" style={{ float: 'right' }} onClick={(e) => { deleteConfiguration(); }}>{configState === 'inactive' ? 'ACTIVATE' : 'DEACTIVATE'}</ButtonComponent>
              : <ButtonComponent cssClass="e-small" iconCss="e-icons e-trash" style={{ float: 'left' }} onClick={(e) => { deleteConfiguration(); }}>{configState === 'inactive' ? 'ACTIVATE' : 'DELETE'}</ButtonComponent>}
              */}
        </div>
  );
});
